exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topbar__rename___30Mxy {\n  font-size: 90%; }\n", ""]);

// exports
exports.locals = {
	"rename": "topbar__rename___30Mxy"
};